// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","button":"App_button__-QG9Z","flex":"App_flex__p3vvI"};